/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ContractWorkRate } from './';
import {
    ContractWorkRateFromJSON,
    ContractWorkRateFromJSONTyped,
    ContractWorkRateToJSON,
} from './';

/**
 * 
 * @export
 * @interface TimeAndMaterialsContractDetailsRequest
 */
export interface TimeAndMaterialsContractDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof TimeAndMaterialsContractDetailsRequest
     */
    projectScope?: string;
    /**
     * 
     * @type {ContractWorkRate}
     * @memberof TimeAndMaterialsContractDetailsRequest
     */
    workRate?: ContractWorkRate;
    /**
     * 
     * @type {Date}
     * @memberof TimeAndMaterialsContractDetailsRequest
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TimeAndMaterialsContractDetailsRequest
     */
    estimatedEndDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof TimeAndMaterialsContractDetailsRequest
     */
    estimatedTotalWorkAmount?: number;
}

/**
 * Check if a given object implements the TimeAndMaterialsContractDetailsRequest interface.
 */
export function instanceOfTimeAndMaterialsContractDetailsRequest(value: object): value is TimeAndMaterialsContractDetailsRequest {
    return true;
}

export function TimeAndMaterialsContractDetailsRequestFromJSON(json: any): TimeAndMaterialsContractDetailsRequest {
    return TimeAndMaterialsContractDetailsRequestFromJSONTyped(json, false);
}

export function TimeAndMaterialsContractDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeAndMaterialsContractDetailsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'projectScope': json['projectScope'] == null ? undefined : json['projectScope'],
        'workRate': json['workRate'] == null ? undefined : ContractWorkRateFromJSON(json['workRate']),
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'estimatedEndDate': json['estimatedEndDate'] == null ? undefined : (new Date(json['estimatedEndDate'])),
        'estimatedTotalWorkAmount': json['estimatedTotalWorkAmount'] == null ? undefined : json['estimatedTotalWorkAmount'],
    };
}

export function TimeAndMaterialsContractDetailsRequestToJSON(value?: TimeAndMaterialsContractDetailsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'projectScope': value['projectScope'],
        'workRate': ContractWorkRateToJSON(value['workRate']),
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString().substring(0,10)),
        'estimatedEndDate': value['estimatedEndDate'] == null ? undefined : ((value['estimatedEndDate']).toISOString().substring(0,10)),
        'estimatedTotalWorkAmount': value['estimatedTotalWorkAmount'],
    };
}

